export function intersection2(left1, right1, left2, right2) {
    if (right1 > left2 && left1 < right2 && right2 - left2 && right1 - left1) {
        if (left1 > left2) {
            if (right1 < right2) {
                return [left1, right1];
            }
            return [left1, right2];
        }
        if (right1 < right2) {
            return [left2, right1];
        }
        return [left2, right2];
    }
    return [];
}
export function doesIntersect2(left1, right1, left2, right2) {
    return right1 > left2 && left1 < right2;
}
export function isContainedWithin(left1, right1, left2, right2) {
    return left2 <= left1 && right2 >= right1;
}
